<script lang="ts">
	import type { IconPosition } from '$lib/components/atoms/iconlabel/types';
	import { goto } from '$app/navigation';
	import { resolve } from '$app/paths';
	import Button from '$lib/components/atoms/button/Button.svelte';
	import * as m from '$paraglide/messages';

	interface Props {
		page: number;
		pageHref: (page: number) => string;
		type: IconPosition;
		disabled?: boolean;
		onSelectPage?: (page: number) => void;
	}

	const {
		page,
		pageHref,
		type,
		disabled = false,
		onSelectPage,
	}: Props = $props();

	function onClick() {
		goto(resolve(pageHref(page) as any));
		onSelectPage?.(page);
	}
</script>

<Button
	variant="ghost"
	size="md"
	icon={type === 'left' ? 'west' : 'east'}
	{disabled}
	iconPosition={type}
	class={disabled ? 'text-neutral' : ''}
	onclick={onClick}
>
	{type === 'left' ? m.pagination__previous() : m.pagination__next()}
</Button>
